import { StyleSheet } from "react-native";

const globals = StyleSheet.create({
  container: {
    flex: 1,
    maxWidth: 425,
    width: "100%",
    alignSelf: "center",
  },
});

export default globals;
